<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      d="M1.9 15.4545H5.5C5.77 15.4545 5.95 15.3636 6.13 15.1818L16.03 5.18182C16.39 4.81818 16.39 4.27273 16.03 3.90909L12.43 0.272727C12.07 -0.0909091 11.53 -0.0909091 11.17 0.272727L1.27 10.2727C1.09 10.4545 1 10.6364 1 10.9091V14.5455C1 15.0909 1.36 15.4545 1.9 15.4545V15.4545ZM2.8 11.2727L11.8 2.18182L14.14 4.54545L5.14 13.6364H2.8V11.2727ZM19 19.0909C19 19.6364 18.64 20 18.1 20H1.9C1.36 20 1 19.6364 1 19.0909C1 18.5455 1.36 18.1818 1.9 18.1818H18.1C18.64 18.1818 19 18.5455 19 19.0909Z"
    ></path>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'EditSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
